<script setup>
import { computed } from 'vue'
import { useGlobalStore } from '@stores/global'
import Button from '@components/global/button.vue'

const global = useGlobalStore()

function parseLink(link) {
	try {
		return JSON.parse(link.replace(/'/g, '"').replace(/([{,]\s*)(\w+)\s*:/g, '$1"$2":'))
	} catch (e) {
		return {}
	}
}
</script>

<template>
	<section class="container" v-if="global.hero?.title">
		<div class="relative flex flex-col-reverse overflow-hidden rounded-2xl bg-secondary hover:cursor-pointer md:flex-row lg:min-h-[700px]">
			<img :src="global.hero?.background" class="absolute left-0 top-0 h-full w-full" alt="" />
			<!-- <img src="https://d2axlk9d80xmkd.cloudfront.net/gardenmother/images/lines/hero.svg" class="absolute bottom-0 right-0 h-full w-full" alt="lines" />
			<img src="https://d2axlk9d80xmkd.cloudfront.net/gardenmother/images/lines/hero.svg" class="absolute bottom-[25%] right-[50%] h-full w-full rotate-180" alt="lines" /> -->

			<div class="relative flex h-full flex-col gap-4 self-end p-12 pr-[8%] lg:w-half">
				<img v-if="global.hero?.logo" :src="global.hero?.logo" alt="" />
				<!-- <template>
					<span class="h9">{{ global.hero?.subtitle }}</span>
					<h1 class="font-extrabold">{{ global.hero?.title }}</h1>
				</template> -->

				<span class="line-clamp-3 text-primaryLight">
					{{ global.hero?.description }}
				</span>
				<div class="mt-4 flex gap-2" v-if="global.hero?.buttons?.length > 0">
					<Button v-for="button in global.hero?.buttons" :label="button.label" :class="{ primary: button.type == 'primary' }" :to="button.link_internal ? parseLink(button.link_internal) : null" :href="button.link_external ? button.link_external : null" />
				</div>
			</div>

			<div class="relative hidden w-half rotate-[15deg] lg:block" v-if="global.hero?.gallery?.length > 0">
				<div class="images animation absolute -right-20 -top-20 grid grid-cols-2 grid-rows-2 gap-4">
					<img v-for="image of global.hero?.gallery" :src="image" :key="image" class="h-[400px] w-[320px] rounded-2xl object-cover" alt="" />
				</div>
			</div>
		</div>
	</section>
</template>

<style scoped>
.container:hover .images {
	@apply -right-16 -top-24 gap-8;
}
</style>
